/**
 * The link to a security in Admin → Securities, used wherever a security's name is a link
 * (buckets, models, their weights, View portfolio).
 *
 * Pedro 2026-10-26: "security names in View portfolios have deep link to Securities, with that
 * security already filtered with the Search" — and, at the smoke, "We don't need the side pane
 * open at first. users can open it by clicking the security row." So the link fills Search with
 * the ISIN (`?q=`) and opens nothing else.
 */
export function securityLink(isin: string | null | undefined): string {
  return isin ? `/admin/securities?q=${encodeURIComponent(isin)}` : '/admin/securities';
}
